import type { IWidgetsConfigMap } from 'components/organisms/widgets-loader/entities/widget-config';

export const WIDGETS_CONFIG: IWidgetsConfigMap = {
    featureStatic_widget: () =>
        import('components/widgets/feature-static-widget/feature-static-widget.component').then(
            ({ FeatureStaticWidgetComponent }) => FeatureStaticWidgetComponent
        ),
    cta_widget: () =>
        import('components/widgets/cta-widget/cta-widget.component').then(
            ({ CtaWidgetComponent }) => CtaWidgetComponent
        ),
    klaxoon_template_widget: () =>
        import('components/widgets/klaxoon-template-widget/klaxoon-template-widget.component').then(
            ({ KlaxoonTemplateWidgetComponent }) => KlaxoonTemplateWidgetComponent
        ),
    intro_widget: () =>
        import('components/widgets/intro-widget/intro-widget.component').then(
            ({ IntroWidgetComponent }) => IntroWidgetComponent
        ),
    intro_share_widget: () =>
        import('components/widgets/into-share-widget/intro-share-widget.component').then(
            ({ IntroShareWidgetComponent }) => IntroShareWidgetComponent
        ),
    feature_slider_widget: () =>
        import('components/widgets/feature-slider-widget/feature-slider-widget.component').then(
            ({ FeatureSliderWidgetComponent }) => FeatureSliderWidgetComponent
        ),
    cards_section_widget: () =>
        import('components/widgets/cards-section-widget/cards-section-widget.component').then(
            ({ CardsSectionWidgetComponent }) => CardsSectionWidgetComponent
        ),
    personal_result_widget: () =>
        import('components/widgets/personal-results-widget/personal-results-widget.component').then(
            ({ PersonalResultsWidgetComponent }) => PersonalResultsWidgetComponent
        ),
    resources: () =>
        import('components/widgets/cards-section-widget/cards-section-widget.component').then(
            ({ CardsSectionWidgetComponent }) => CardsSectionWidgetComponent
        ),
    customer_quote_widget: () =>
        import('components/widgets/customer-quotes-widget/customer-quotes-widget.component').then(
            ({ CustomerQuotesWidgetComponent }) => CustomerQuotesWidgetComponent
        ),
    solution: () =>
        import('components/widgets/cards-section-widget/cards-section-widget.component').then(
            ({ CardsSectionWidgetComponent }) => CardsSectionWidgetComponent
        ),
    quotes_slider_widget: () =>
        import('components/widgets/quotes-slider-widget/quotes-slider-widget.component').then(
            ({ QuotesSliderWidgetComponent }) => QuotesSliderWidgetComponent
        ),
    g2_review_widget: () =>
        import('components/widgets/reviews-widget/reviews-widget.component').then(
            ({ ReviewsWidgetComponent }) => ReviewsWidgetComponent
        ),
    contact_sales_organism_widget: () =>
        import('components/widgets/contact-sales-section-widget/contact-sales-section-widget.component').then(
            ({ ContactSalesSectionWidgetComponent }) => ContactSalesSectionWidgetComponent
        ),
    intro_slider_widget: () =>
        import('components/widgets/intro-slider-widget/intro-slider-widget.component').then(
            ({ IntroSliderWidgetComponent }) => IntroSliderWidgetComponent
        ),
    related_content_recommendation_widget: () =>
        import('components/widgets/intro-slider-widget/intro-slider-widget.component').then(
            ({ IntroSliderWidgetComponent }) => IntroSliderWidgetComponent
        ),
    trial_form: () =>
        import('components/widgets/cta-widget/cta-widget.component').then(
            ({ CtaWidgetComponent }) => CtaWidgetComponent
        ),
    faq_widget: () =>
        import('components/widgets/faq-widget/faq-widget.component').then(
            ({ FaqWidgetComponent }) => FaqWidgetComponent
        ),
    logoroll_widget: () =>
        import('components/widgets/logoroll-widget/logoroll-widget.component').then(
            ({ LogorollWidgetComponent }) => LogorollWidgetComponent
        ),
    long_read_widget: () =>
        import('components/widgets/long-read/long-read.component').then(({ LongReadComponent }) => LongReadComponent),
    cards_collection_widget: () =>
        import('components/widgets/swipe-cards-widget/swipe-cards-widget.component').then(
            ({ SwipeCardsWidgetComponent }) => SwipeCardsWidgetComponent
        ),
    'on-page_marketo_form_widget': () =>
        import('components/widgets/marketo-form-section/marketo-form-section.component').then(
            ({ MarketoFormSectionComponent }) => MarketoFormSectionComponent
        ),
    agenda_widget: () =>
        import('components/widgets/agenda/agenda.component').then(({ AgendaComponent }) => AgendaComponent),
    speaker_cards_widget: () =>
        import('components/widgets/speakers/speaker-cards-widget.component').then(
            ({ SpeakerCardsWidgetComponent }) => SpeakerCardsWidgetComponent
        ),
    demo_widget: () => import('components/widgets/demo/demo.component').then(({ DemoComponent }) => DemoComponent),
    demo_page_widget: () =>
        import('components/widgets/page-demo-widget/page-demo-widget.component').then(
            ({ PageDemoWidgetComponent }) => PageDemoWidgetComponent
        ),
    customer_summary_widget: () =>
        import('components/widgets/customer-summary-widget/customer-summary-widget.component').then(
            ({ CustomerSummaryWidgetComponent }) => CustomerSummaryWidgetComponent
        ),
    media_section_widget: () =>
        import('components/widgets/media-section/media-section.component').then(
            ({ MediaSectionComponent }) => MediaSectionComponent
        ),
    stories_widget: () =>
        import('components/widgets/stories/stories.component').then(({ StoriesComponent }) => StoriesComponent),
    gartner_widget: () =>
        import('components/widgets/gartner-widget/gartner-widget.component').then(
            ({ GartnerWidgetComponent }) => GartnerWidgetComponent
        ),
    images_in_a_row_widget: () =>
        import('components/widgets/images-in-a-row/images-in-a-row.component').then(
            ({ ImagesInARowComponent }) => ImagesInARowComponent
        ),
    custom_html_widget: () =>
        import('components/widgets/custom-html/custom-html.component').then(
            ({ CustomHtmlWidgetComponent }) => CustomHtmlWidgetComponent
        ),
    pricing_widget: () =>
        import('components/widgets/pricing-widget/pricing-widget.component').then(
            ({ PricingWidgetComponent }) => PricingWidgetComponent
        ),
    glossary_widget: () =>
        import('components/widgets/glossary/glossary.component').then(({ GlossaryComponent }) => GlossaryComponent),
    faq_guides_widget: () =>
        import('components/widgets/faq-guides-widget/faq-guides-widget.component').then(
            ({ FaqGuidesWidgetComponent }) => FaqGuidesWidgetComponent
        ),
    admonitions_widget: () =>
        import('components/widgets/admonitions-widget/admonitions-widget.component').then(
            ({ AdmonitionsWidgetComponent }) => AdmonitionsWidgetComponent
        ),
    search_field_widget: () =>
        import('components/widgets/search-widget/search-widget.component').then(
            ({ SearchWidgetComponent }) => SearchWidgetComponent
        ),
    search_result_widget: () =>
        import('components/widgets/search-widget/search-widget.component').then(
            ({ SearchWidgetComponent }) => SearchWidgetComponent
        ),
    roi_calculator_widget: () =>
        import('components/widgets/roi-calculator/roi-widget.component').then(
            ({ RoiWidgetComponent }) => RoiWidgetComponent
        ),
    short_roi_calculator_widget: () =>
        import('components/widgets/short-roi-calculator/short-roi-widget.component').then(
            ({ ShortRoiWidgetComponent }) => ShortRoiWidgetComponent
        ),
    integrations: () =>
        import('components/widgets/integrations/integrations.component').then(
            ({ IntegrationsComponent }) => IntegrationsComponent
        ),
    integrations_groups: () =>
        import('components/widgets/integrations-groups/integrations-groups.component').then(
            ({ IntegrationsGroupsComponent }) => IntegrationsGroupsComponent
        ),
    chips_widget: () => import('components/widgets/chips/chips.component').then(({ ChipsWidget }) => ChipsWidget),
    secondary_menu_widget: () =>
        import('components/widgets/secondary-menu-widget/secondary-menu-widget.component').then(
            ({ SecondaryMenuWidgetComponent }) => SecondaryMenuWidgetComponent
        ),
    filter_widget_v2: () =>
        import('components/widgets/cards-with-filters-v2/cards-with-filters-v2.component').then(
            ({ CardsWithFiltersV2Component }) => CardsWithFiltersV2Component
        ),
    feature_scroll_widget: () =>
        import('components/widgets/feature-scroll-widget/feature-scroll-widget.component').then(
            ({ FeatureScrollWidgetComponent }) => FeatureScrollWidgetComponent
        ),
    pricing_comparison_widget: () =>
        import('components/widgets/pricing-comparison-widget/pricing-comparison-widget.component').then(
            ({ PricingComparisonWidgetComponent }) => PricingComparisonWidgetComponent
        ),
    wrike_open_app_widget: () =>
        import('components/widgets/open-wrike-app-widget/open-wrike-app-widget.component').then(
            ({ OpenWrikeAppWidgetComponent }) => OpenWrikeAppWidgetComponent
        ),
    add_on_integrate_widget: () =>
        import('components/widgets/add-on-integrate-widget/add-on-integrate-widget.component').then(
            ({ AddOnIntegrateWidgetComponent }) => AddOnIntegrateWidgetComponent
        ),
    resend_widget: () =>
        import('components/widgets/resend-widget/resend-widget.component').then(
            ({ ResendWidgetComponent }) => ResendWidgetComponent
        ),
    recommendations_widget: () =>
        import('components/widgets/recommendations-widget/recommendations-widget.component').then(
            ({ RecommendationsWidgetComponent }) => RecommendationsWidgetComponent
        ),
    decline_invitation_widget: () =>
        import('components/widgets/decline-invitation-widget/decline-invitation-widget.component').then(
            ({ DeclineInvitationWidgetComponent }) => DeclineInvitationWidgetComponent
        ),
    qr_code_widget: () =>
        import('components/widgets/qr-code-widget/qr-code-widget.component').then(
            ({ QrCodeWidgetComponent }) => QrCodeWidgetComponent
        ),
    qaa_widget: () =>
        import('components/widgets/qaa-widget/qaa-widget.component').then(
            ({ QaaWidgetComponent }) => QaaWidgetComponent
        ),
    promo_with_numbers_widget: () =>
        import('components/widgets/promo-with-numbers-widget/promo-with-numbers-widget.component').then(
            ({ PromoWithNumbersWidgetComponent }) => PromoWithNumbersWidgetComponent
        ),
    smart_search_widget: () =>
        import('components/widgets/smart-search-widget/smart-search-widget.component').then(
            ({ SmartSearchWidgetComponent }) => SmartSearchWidgetComponent
        ),
    intro_sidebar_widget: () =>
        import('components/widgets/intro-sidebar-widget/intro-sidebar-widget.component').then(
            ({ IntroSidebarWidgetComponent }) => IntroSidebarWidgetComponent
        ),
    competitors_comparison_widget: () =>
        import('components/widgets/competitors-comparison-widget/competitors-comparison-widget.component').then(
            ({ CompetitorsComparisonWidgetComponent }) => CompetitorsComparisonWidgetComponent
        ),
    bento_grid_widget: () =>
        import('components/widgets/bento-widget/bento-widget.component').then(
            ({ BentoWidgetComponent }) => BentoWidgetComponent
        ),
    video_quotes_widget: () =>
        import('components/widgets/video-quotes-widget/video-quotes-widget.component').then(
            ({ VideoQuotesWidgetComponent }) => VideoQuotesWidgetComponent
        ),
    workflow_solutions_widget: () =>
        import('components/widgets/workflow-solutions-widget/workflow-solutions-widget.component').then(
            ({ WorkflowSolutionsWidgetComponent }) => WorkflowSolutionsWidgetComponent
        ),
    article_widget: () =>
        import('components/widgets/article-widget/article-widget.component').then(
            ({ ArticleWidgetComponent }) => ArticleWidgetComponent
        ),
    experiment_intro_with_constructor_widget: () =>
        import('components/widgets/experiment-intro-with-constructor/experiment-intro-with-constructor.component').then(
            ({ ExperimentIntroWithConstructorComponent }) => ExperimentIntroWithConstructorComponent
        ),
    experiment_intro_with_interaction_widget: () =>
        import('components/widgets/experiment-intro-with-interaction-widget/experiment-intro-with-interaction-widget.component').then(
            ({ ExperimentIntroWithInteractionWidgetComponent }) => ExperimentIntroWithInteractionWidgetComponent
        ),
};
